import React, { useEffect, useRef, useState } from "react";
// import config from "../../../config";
import client from "../../../clients";
import flatpickr from "flatpickr";
import Toast from "../../../lib/toast";
import { payBalanceAmount } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import { getTotalPayment } from "../../../lib/utils";
import { getAllPayments } from "../../payments/helper/api";

const BalancePaymentModal = (props) => {

  const [payment,setPayment] = useState('')
  const [currentElementId, setCurrentElementId] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [isButtonLock,setButtonLock] = useState(false)
  const [reason,setReason] = useState('');
  const dueDate = useRef(null);
  const [newDueDate, setNewDueDate] = useState("");
  const [isShowDueDate,setShowDueDate] = useState(false);
  const [paymentSources, setPaymentSources] = useState({
    online: ["NEFT", "RTGS", "IMPS", "UPI", "Credit Card", "Debit Card", "Juice"],
    wallet: ["Paytm", "PhonePe", "Google Pay", "Amazon Pay"]
  });
  const cardTypes = ["Visa", "Mastercard", "Zeta", "Rupay", "Amex", "Bajaj Finserv", "Tata Card"];
  const [invoiceDetails, setInvoiceDetails] = useState({
    paymentMode: "online",
    paymentSource: "",
    chequeNumber: "",
    bankName: "",
    upiId: "",
    comment: "",
    transactionID: ""
  });
  const {user,token} = isAuthenticated();
  const [wayOfPayment,setWayOfPayment]= useState('');
  const [skipAggregateTax, setSkipAggregateTax] = useState(false);





  const handleChooseOther = event =>{
      setWayOfPayment('')
      setReason('');
      setInvoiceDetails({
        ...invoiceDetails,
        paymentMode: "online",
        paymentSource: "",
        chequeNumber: "",
        bankName: "",
        upiId: "",
        comment: "",
        transactionID: ""
      })
  }

  const handleReason = event =>{
    setReason(event.target.value);
  }

   const handlePaymentMode = paymentMode => event =>{
    try{
      setInvoiceDetails(oldstate=>{

        oldstate.paymentMode = paymentMode;
        oldstate.paymentSource = "";
        oldstate.chequeNumber = "";
        oldstate.bankName = "";
        oldstate.upiId = "";
        oldstate.comment = "";
        oldstate.transactionID = "";

        return {
          ...oldstate
        }
      })
    }catch(error){
      
    }
  }

  const handleSelectPaymentSource = (source) => {
    setInvoiceDetails((oldState) => ({
      ...oldState,
      paymentSource: source
    }))
  }

  const handleSelectCard = (getCardType) => {
    setInvoiceDetails((oldState) => ({
      ...oldState,
      cardType: getCardType
    }))
  }


  const handleFullPayment = () =>{
    setWayOfPayment('full-payment');
    setReason('');
    setInvoiceDetails({
      ...invoiceDetails,
      paymentMode: "online",
      paymentSource: "",
      chequeNumber: "",
      bankName: "",
      upiId: "",
      comment: "",
      transactionID: ""
    })
  }

  const handleWriteOffBalance = () =>{
    setWayOfPayment('write-off')
    setReason('');
    setInvoiceDetails({
      ...invoiceDetails,
      paymentMode: "online",
      paymentSource: "",
      chequeNumber: "",
      bankName: "",
      upiId: "",
      comment: "",
      transactionID: ""
    })
  }

  const toggleInputFields = (id) => event => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id)
      if (event) {
        let interval = setInterval(() => {
          let element = event.target.querySelector('input');
          if (element) {
            element.focus();
            clearInterval(interval)
          }
        }, 0);
      }
    }
  }

  const handleChange = (name,value) => event => {
    if(name == "total-amount"){
      let balance = payment?.package?.[0]?.balance_amount ? parseInt(payment.package[0].balance_amount) : payment?.membership?.[0]?.balance_amount?parseInt(payment.membership[0].balance_amount):0;
      let amount = event.target.value?parseInt(event.target.value):0;
      setTotalAmount(event.target.value);

      setTimeout(()=>{
        if(amount == 0) return setShowDueDate(false)
        if(amount<0){
          setTotalAmount('');
          setShowDueDate(false)
          return new Toast({
            type:'info',
            duration:3000,
            message:"Amount should not be less then zero"
          })
        }

        if(amount>balance){
          setTotalAmount('');
          setShowDueDate(false)
          return new Toast({
            type:'info',
            duration:3000,
            message:"Amount should not be more then balance"
          })
        }

        if(amount<balance){
          setShowDueDate(true)
        }else{
          setShowDueDate(false)
        }
      },1000);
    }else{
      value = !value ? event.target.value : value; 
      setInvoiceDetails({
        ...invoiceDetails,
        [name]: value
      });
    }
  }

  const PayBalanceAmount = async event =>{
    setButtonLock(true)

    console.log("Hello Membership props",props.payment.membership);
    // return;

    try{
      const payload = {
        newDueDate,
        mode:invoiceDetails.paymentMode,
        amount:wayOfPayment == 'full-payment'? payment?.package?.[0]?.balance_amount ? payment.package[0].balance_amount : payment.membership[0].balance_amount : totalAmount,
        ...invoiceDetails
      }

      if (props?.payment?.membership?.[0]?.taxes?.length > 0) {
        payload.appliedTaxes = props.payment.membership[0].taxes;
      }

      if(wayOfPayment == 'write-off'){
        payload.isWriteOff = true;
        payload.reason = reason

        if(skipAggregateTax){
          payload.skipAggregateTax = "true";
        }else{
          payload.skipAggregateTax = "false";
        }
      }

      if(payment?.package?.[0]?._id){  
        payload.packageId = payment.package[0]._id
      }

      delete payload.paymentMode;

      let response = await payBalanceAmount(user._id,token,payment._id,payload);

      console.log(response);

      if(response.error){
        new Toast({
          type:'error',
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:'success',
          duration:3000,
          message:response
        })
        props.togglePaymentModal("balance-payment");
        props.reload();
      }

    }catch(error){
      
    }
    setButtonLock(false)
  }

  const toggleSkipAggregateTax = () => {
    setSkipAggregateTax(!skipAggregateTax)
  }


  useEffect(() => {
     try{
      const dueDateFlatPicker = flatpickr(dueDate.current, {
        disableMobile: true,
        dateFormat: "Y-m-d",
        onChange: ([date]) => {
          const istDate = date.toLocaleDateString('en-CA', {
            timeZone: 'Asia/Kolkata'
          });
          setNewDueDate(istDate);
        }
      });
      
      return () => {
        dueDateFlatPicker.destroy();
      }
     }catch(error){

     }
  }, [currentElementId]);


  useEffect(()=>{
    if(invoiceDetails.paymentMode){
      if(!wayOfPayment && isShowDueDate && newDueDate && totalAmount){
        setButtonLock(false)
      }else if(!wayOfPayment && !isShowDueDate && totalAmount){
        setButtonLock(false)
      }else if(wayOfPayment == 'full-payment' || wayOfPayment == 'write-off'){
        setButtonLock(false)
      }else {
        setButtonLock(true)
      }
    }else{
      setButtonLock(true);
    }
  },[invoiceDetails,newDueDate,totalAmount,isShowDueDate,wayOfPayment])

  useEffect(async ()=>{
    if(props.paymentId){
      let response = await getAllPayments(user._id,token,{
        ids:[props.paymentId]
      })
      if(response?.[0]?._id){
        setPayment(response?.[0])
      }
    }else{
      setPayment(props.payment);
    }
  },[props.payment,props.paymentId])

  if(!payment) return <></>;

  return(
    <div className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div className={`${window.innerWidth > 767 ? "modal-container balance-payment-membership-modal flex-item" : "w-full h-full"}`}
      style={{
        width: window.innerWidth > 767 ? "44%" : "100%",
        height: window.innerWidth > 767 ? "80vh" : "100%",
        maxHeight: window.innerWidth > 767 ? "80vh" : "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8' width="24" height="24" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.375 9.5C16.375 10.3288 16.0458 11.1237 15.4598 11.7097C14.8736 12.2958 14.0787 12.625 13.25 12.625C12.4213 12.625 11.6263 12.2958 11.0403 11.7097C10.4542 11.1237 10.125 10.3288 10.125 9.5C10.125 8.6712 10.4542 7.87634 11.0403 7.29029C11.6263 6.70424 12.4213 6.375 13.25 6.375C14.0787 6.375 14.8736 6.70424 15.4598 7.29029C16.0458 7.87634 16.375 8.6712 16.375 9.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M18.25 0.75C21.35 0.75 23.4875 1.23 24.6662 1.595C25.345 1.805 25.75 2.44875 25.75 3.15875V15.3525C25.75 16.7462 24.215 17.795 22.845 17.5362C21.67 17.315 20.1388 17.1362 18.25 17.1362C12.3125 17.1362 10.8875 19.3937 2.18126 17.4737C1.77351 17.3813 1.40946 17.1526 1.14925 16.8253C0.889032 16.4981 0.748205 16.0918 0.750017 15.6737V3.15C0.750017 1.93 1.90001 1.04125 3.09751 1.27875C10.9963 2.84625 12.5263 0.75 18.25 0.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M0.75 5.74902C3.18875 5.74902 5.38125 3.75527 5.66125 1.69152M21.375 1.37402C21.375 3.92402 23.5812 6.33527 25.75 6.33527M25.75 13.249C23.375 13.249 21.075 14.8865 20.8775 17.1215M5.75 17.619C5.75 16.2929 5.22321 15.0211 4.28554 14.0835C3.34785 13.1458 2.07609 12.619 0.75 12.619" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item fs-18 font-weight-600 color-white m-l-4">Balance Payment</p>
              </div>
              <div onClick={()=>props.togglePaymentModal("balance-payment")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }

        <div className="w-full"  style={{ flex: 1,minHeight: 0,overflowY: "auto"}}>
          <div className="w-full" style={{padding:"12px"}}>
            <div className="w-full" style={{background:"#ffffff", borderRadius:"12px", padding:"2px"}}>

              <div className="w-full" style={{borderRadius:"12px"}}>
                <div className="flex-item d-flex" style={{borderBottom:"1px dashed #9a9a9a", padding:"12px"}}>
                  {
                      payment.user.length && (
                        payment.user[0].profileID?(
                          <img style={{width:"40px", height:"40px", borderRadius:"100%"}} className="flex-item" src={`${client.config.API_URL}/image/file/${payment.user[0].profileID}/30/30/70?${Date.now()}`} />
                        ):(
                          <div className='table-item-profile d-flex flex-item' style={{
                            backgroundColor: "#5d883c"
                          }}>
                            <p className='flex-item' style={{
                              color: "#ffffff",
                              margin: "0 auto",
                              fontSize: 14,
                            }}>{`${payment.user[0].name}`.trim()[0]}</p>
                          </div>
                        )
                      )
                    }
                  <div className="flex-item m-l-12">
                    <p className="flex-item font-weight-700 fs-16">{payment.user.length && payment.user[0].name}</p>
                    <p className="flex-item fs-12 color-grey-02">Member</p>
                  </div>
                </div>
                <div className="w-full" style={{padding:"12px"}}>
                  <div className="flex-item d-flex space-between m-b-12">
                    <p className="flex-item">Invoice Number:</p>
                    <p className="flex-item font-weight-700" style={{width:"50%"}}>{payment.invoice_number}</p>
                  </div>
                  <div className="flex-item d-flex space-between">
                    <p className="flex-item">Invoice Date:</p>
                    <p className="flex-item font-weight-700" style={{width:"50%"}}>{payment.invoiceDateString}</p>
                  </div>
                </div>
              </div>
              <div className="w-full" style={{padding:"12px", borderRadius:"4px 4px 12px 12px", background:"#E0E9E2"}}>
                <div className="flex-item d-flex space-between m-b-12">
                  <p className="flex-item">Total Amount:</p>
                  <p className="flex-item font-weight-700" style={{width:"50%"}}>₹ {payment?.membership[0]?.billedInfo?.payableAmount?.$numberDecimal}</p>
                </div>
                <div className="flex-item d-flex space-between m-b-12">
                  <p className="flex-item">Paid Amount:</p>
                  <p className="flex-item font-weight-700" style={{width:"50%"}}>₹ {getTotalPayment(payment)}</p>
                </div>
                <div className="flex-item d-flex space-between">
                  <p className="flex-item">Current Balance Amount:</p>
                  <p className="flex-item font-weight-700 color-red" style={{width:"50%"}}>₹ {payment?.package?.[0]?.balance_amount ? payment.package[0].balance_amount : payment.membership[0].balance_amount ? payment.membership[0].balance_amount : ""}</p>
                </div>
              </div>              
            </div>

            <div className="d-flex m-t-16">
              <div className="flex-item d-flex m-r-20">
                <input onClick={()=>handleFullPayment()} type="radio" name="remaining-amount" className="flex-item m-r-12" checked={wayOfPayment == 'full-payment'} style={{width:"20px", height:"20px"}} />
                <p className="flex-item">Full Remaining Amount</p>
              </div>

              <div className="flex-item d-flex m-r-20">
                <input onClick={()=>handleWriteOffBalance()} checked={wayOfPayment == 'write-off'} type="radio" name="remaining-amount" className="flex-item m-r-12" style={{width:"20px", height:"20px"}} />
                <p className="flex-item">Write Off Balance</p>
              </div>

              <div className="flex-item d-flex">
                <input onClick={handleChooseOther} checked={!wayOfPayment} type="radio" name="remaining-amount" className="flex-item m-r-12" style={{width:"20px", height:"20px"}} />
                <p className="flex-item">Other</p>
              </div>
            </div>

            {
              !wayOfPayment && (
                <div className="m-b-12">
                <div onClick={toggleInputFields('total-amount')} className={`${currentElementId == "total-amount" || totalAmount ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-t-12`} style={{ border: currentElementId == "total-amount" || totalAmount ? "1px solid #5D883C" : "", width:"48%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "total-amount" || totalAmount ? "10px" : "14px", color: currentElementId == "total-amount" || totalAmount ? "#000000" : "", transition: "180ms" }}>Amount to Pay (₹)</p>
                  </div>
                  <input id="total-amount" onChange={handleChange('total-amount')} placeholder='Enter Amount' value={totalAmount} className={`${currentElementId == "total-amount" || totalAmount ? "active-input-field" : "inactive-input-field"}`} style={{color:"#5D883C", fontWeight:"600", fontSize:"16px"}} type="number" />
                </div>

               
                  {
                    isShowDueDate && (
                      <div className="d-flex space-between p-t-12 m-t-20 p-b-12 m-b-12" style={{borderTop:"1px dashed #f15d22", borderBottom:"1px dashed #f15d22"}}>
                        <div className="flex-item">
                          <p className="font-weight-600">New Balance Amount:</p>
                          <p className="font-weight-700 fs-18 color-red m-t-4">₹ {wayOfPayment ? 0: totalAmount ? parseInt(payment?.package?.[0]?.balance_amount ? parseInt(payment.package[0].balance_amount) : payment.membership[0].balance_amount) - parseInt(totalAmount) : payment.membership[0].balance_amount}</p>
                        </div>
                        <div onClick={toggleInputFields('due-date')} className={`${(currentElementId == 'due-date' || newDueDate) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'due-date' || newDueDate) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'due-date' || newDueDate) ? "10px" : "14px", color: (currentElementId == 'due-date' || newDueDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Due Date <span className="color-red">*</span></p>
                          </div>
                          <input id="due-date" ref={dueDate} value={newDueDate} placeholder="DD/MM/YYYY" style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'due-date' || newDueDate) ? "active-input-field" : "inactive-input-field"}`} type="string" />
                        </div>
                      </div>
                    )
                  }
              </div>
              )
            }

            {wayOfPayment != "write-off" &&
            <>
              <p className="color-dark-blue font-weight-600 fs-14 m-t-20">Payment Mode</p>
              <div className="d-flex-wrap space-between m-t-8">
                <div onClick={handlePaymentMode("online")} className="flex-item d-flex">
                  <input className="flex-item m-r-8" type="radio"  checked={invoiceDetails.paymentMode == "online"} style={{width:"20px", height:"20px"}}/>
                  <p className="flex-item font-weight-600 fs-16">Online</p>
                </div>
                <div onClick={handlePaymentMode("wallet")} className="flex-item d-flex">
                  <input checked={invoiceDetails.paymentMode == "wallet"} className="flex-item m-r-8" type="radio"  style={{width:"20px", height:"20px"}}/>
                  <p className="flex-item font-weight-600 fs-16">Wallet</p>
                </div>
                <div onClick={handlePaymentMode("cheque")} className="flex-item d-flex">
                  <input checked={invoiceDetails.paymentMode == "cheque"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} />
                  <p className="flex-item font-weight-600 fs-16">Cheque</p>
                </div>
                <div onClick={handlePaymentMode("cash")} className="flex-item d-flex">
                  <input checked={invoiceDetails.paymentMode == "cash"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}}/>
                  <p className="flex-item font-weight-600 fs-16">Cash</p>
                </div>
                <div onClick={handlePaymentMode("other")} className="flex-item d-flex">
                  <input checked={invoiceDetails.paymentMode == "other"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}}/>
                  <p className="flex-item font-weight-600 fs-16">Other</p>
                </div>
              </div>

              <div className="m-t-16 p-t-4 p-b-4">

              {
                (invoiceDetails.paymentMode == "online" || invoiceDetails.paymentMode == "wallet") && (
                  <div className="w-full">
                    <div onClick={toggleInputFields('paymentSource')}  className={`${currentElementId == "paymentSource" || invoiceDetails.paymentSource ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} 
                        style={{ border: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
  
                          <div className='d-flex w-full space-between'>
                            <div className='flex-item'>
                              <div className="flex-item d-flex">
                                <svg className="flex-item m-r-4" width={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} height={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                </svg>

                                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", color: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>
                                  Payment is done via
                                </p>
                              </div>

      
                                 <input readOnly id="paymentSource" value={invoiceDetails.paymentSource}  type="text" className={`${(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "active-input-field" : "inactive-input-field"}`} placeholder="Payment is done via" />
                            </div>

                              <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                <svg className="flex-item" style={{ transform: currentElementId == "paymentSource" ? "rotate(180deg)" : "" }} width="13" height="8" viewBox="0 0 13 8" fill="none">
                                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                </svg>
                              </div>
                                 
                                 {
                                    currentElementId == "paymentSource" && (
                                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", padding: "0", maxHeight: "200px",overflowY: "auto",WebkitOverflowScrolling: "touch"}}>
                                        {
                                          invoiceDetails.paymentMode == "online" && (
                                            <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                              {
                                                paymentSources.online.map((data, index) => {
                                                  return (
                                                    <div key={index} onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                                      <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                                    </div>
                                                  )
                                                })
                                              }
                                            </div>
                                          )
                                        }

                                        {
                                          invoiceDetails.paymentMode == "wallet" && (
                                            <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                              {
                                                paymentSources.wallet.map((data, index) => {
                                                  return (
                                                    <div key={index} onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                                      <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                                    </div>
                                                  )
                                                })
                                              }
                                            </div>
                                          )
                                        }
                                      </div>
                                    )
                                  }
                      
                          </div>
                    </div>
                  </div>  
                )  
              }

              {
                invoiceDetails.paymentMode == "cheque" && (
                  <div className="w-full">
                    <div onClick={toggleInputFields('cheque-number')} className={`${currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "1px solid var(--darkBlue)" : "" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "cheque-number" || invoiceDetails.chequeNumber ? "10px" : "14px", color: currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Cheque Number</p>
                      </div>
                      <div className={`${currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                        <input className="flex-item" id="cheque-number" value={invoiceDetails.chequeNumber} placeholder="Enter Cheque Number" onChange={handleChange("chequeNumber")} style={{width:"100%"}} type="text" />
                      </div>
                    </div>
                  </div>
                ) 
              }

              {
                (invoiceDetails.paymentSource == "NEFT" || invoiceDetails.paymentSource == "RTGS" || invoiceDetails.paymentSource == "IMPS" ) && (
                  <div className="w-full">
                    <div onClick={toggleInputFields('bank-name')} className={`${currentElementId == "bank-name" || invoiceDetails.bankName ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "bank-name" || invoiceDetails.bankName ? "1px solid var(--darkBlue)" : "" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "bank-name" || invoiceDetails.bankName ? "10px" : "14px", color: currentElementId == "bank-name" || invoiceDetails.bankName ? "var(--darkBlue)" : "", transition: "180ms" }}>Bank Name</p>
                      </div>
                      <div className={`${currentElementId == "bank-name" || invoiceDetails.bankName ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                        <input className="flex-item" id="bank-name" value={invoiceDetails.bankName} placeholder="Enter Bank Name" onChange={handleChange("bankName")} style={{width:"100%"}} type="text" />
                      </div>
                    </div>
                  </div>
                )
              }

                {
                    (invoiceDetails.paymentSource == "Credit Card" || invoiceDetails.paymentSource == "Debit Card") && (
                      <div onClick={toggleInputFields("card-type")} 
                          className={`${currentElementId == "card-type" || invoiceDetails.cardType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} 
                          style={{ border: (currentElementId == "card-type" || invoiceDetails.cardType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                        
                        <div className='d-flex w-full space-between'>
                          <div className='flex-item'>
                            <div className="flex-item d-flex">
                              <svg className="flex-item m-r-4" width={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} height={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75602 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "#6d6d6d"}/>
                              </svg>
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", color: (currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>
                                Payment is done via
                              </p>
                            </div>

                            <input readOnly id="card-type" 
                                  value={invoiceDetails.cardType || ""} 
                                  type="text"
                                  className={`${(currentElementId == "card-type" || invoiceDetails.cardType) ? "active-input-field" : "inactive-input-field"}`}
                                  placeholder="Payment is done via" />
                          </div>

                          <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                            <svg className="flex-item" style={{ transform: currentElementId == "card-type" ? "rotate(180deg)" : "" }} width="13" height="8" viewBox="0 0 13 8" fill="none">
                              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                            </svg>
                          </div>

                          {
                            currentElementId == "card-type" && (
                              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", padding: "0",  maxHeight: "220px",overflowY: "auto",WebkitOverflowScrolling: "touch"}}>
                                <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                  {
                                    cardTypes.map((data, index) => {
                                      return (
                                        <div key={index} onClick={()=>handleSelectCard(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                          <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    )
                  }

              {
                (invoiceDetails.paymentSource == "Credit Card" || invoiceDetails.paymentSource == "Debit Card") && (
                  <div onClick={toggleInputFields('approved-code')} className={`${currentElementId == "approved-code" || invoiceDetails.approvedCode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full`} style={{ border: currentElementId == "approved-code" || invoiceDetails.approvedCode ? "1px solid var(--darkBlue)" : "" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "approved-code" || invoiceDetails.approvedCode ? "10px" : "14px", color: currentElementId == "approved-code" || invoiceDetails.approvedCode ? "var(--darkBlue)" : "", transition: "180ms" }}>Approved Code</p>
                    </div>
                    <div className={`${currentElementId == "approved-code" || invoiceDetails.approvedCode ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                      <input className="flex-item" id="approved-code" value={invoiceDetails.approvedCode} placeholder="Enter Approved Code" onChange={handleChange("approvedCode")} style={{width:"100%"}} type="text" />
                    </div>
                  </div>
                )
              }

              {
                (invoiceDetails.paymentSource == "UPI") && (
                  <div onClick={toggleInputFields('upi-id')} className={`${currentElementId == "upi-id" || invoiceDetails.upiId ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "upi-id" || invoiceDetails.upiId ? "1px solid var(--darkBlue)" : "" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "upi-id" || invoiceDetails.upiId ? "10px" : "14px", color: currentElementId == "upi-id" || invoiceDetails.upiId ? "var(--darkBlue)" : "", transition: "180ms" }}>Aadhaar No./Mobile No./</p>
                    </div>
                    <div className={`${currentElementId == "upi-id" || invoiceDetails.upiId ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                      <input className="flex-item" id="upi-id" value={invoiceDetails.upiId} placeholder="Enter Aadhaar or Mobile No. or UPI ID" onChange={handleChange("upiId")} style={{width:"100%"}} type="text" />
                    </div>
                  </div>
                )
              }

              {
                invoiceDetails.paymentSource == "Paytm" || invoiceDetails.paymentSource == "PhonePe" || invoiceDetails.paymentSource == "Google Pay" || invoiceDetails.paymentSource == "Amazon Pay" && (
                  <div onClick={toggleInputFields('payment-number')} className={`${currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "1px solid var(--darkBlue)" : "" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "payment-number" || invoiceDetails.paymentNumber ? "10px" : "14px", color: currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment mobile number</p>
                    </div>
                    <div className={`${currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                      <input className="flex-item" id="payment-number" value={invoiceDetails.paymentNumber} placeholder="Enter payment mobile number" onChange={handleChange("paymentNumber")} style={{width:"100%"}} type="text" />
                    </div>
                  </div>
                )
              }

              {
                (invoiceDetails.paymentSource == "NEFT" || invoiceDetails.paymentSource == "RTGS" || invoiceDetails.paymentSource == "IMPS" || invoiceDetails.paymentSource == "UPI" || invoiceDetails.paymentSource == "Juice" || invoiceDetails.paymentSource == "Paytm" || invoiceDetails.paymentSource == "PhonePe" || invoiceDetails.paymentSource == "Google Pay" || invoiceDetails.paymentSource == "Amazon Pay") && (
                  <div onClick={toggleInputFields('transaction-id')} className={`${currentElementId == "transaction-id" || invoiceDetails.transactionID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full`} style={{ border: currentElementId == "transaction-id" || invoiceDetails.transactionID ? "1px solid var(--darkBlue)" : "" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "transaction-id" || invoiceDetails.transactionID ? "10px" : "14px", color: currentElementId == "transaction-id" || invoiceDetails.transactionID ? "var(--darkBlue)" : "", transition: "180ms" }}>Transaction ID</p>
                    </div>
                    <div className={`${currentElementId == "transaction-id" || invoiceDetails.transactionID ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                      <input className="flex-item" id="transaction-id" value={invoiceDetails.transactionID} placeholder="Enter Transaction ID" onChange={handleChange("transactionID")} style={{width:"100%"}} type="text" />
                    </div>
                  </div>
                )
              }


              {
                invoiceDetails.paymentMode == "other" && (
                  <div onClick={toggleInputFields('comment')} className={`${currentElementId == "comment" || invoiceDetails.comment ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "comment" || invoiceDetails.comment ? "1px solid var(--darkBlue)" : "" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "comment" || invoiceDetails.comment ? "10px" : "14px", color: currentElementId == "comment" || invoiceDetails.comment ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment *</p>
                    </div>
                    <div className={`${currentElementId == "comment" || invoiceDetails.comment ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                      <input className="flex-item" id="comment" value={invoiceDetails.comment} placeholder="Enter Comment" onChange={handleChange("comment")} style={{width:"100%"}} type="text" />
                    </div>
                  </div>
                )
              }
              </div>
            </>}
            
            {wayOfPayment == 'write-off' &&  
              <div className="m-t-16 p-t-4 p-b-4">
                <div onClick={toggleInputFields('reason')} className={`${currentElementId == "reason" || reason ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "reason" || reason ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "reason" || reason ? "10px" : "14px", color: currentElementId == "reason" || reason ? "var(--darkBlue)" : "", transition: "180ms" }}>Reason for write off *</p>
                  </div>
                  <div className={`${currentElementId == "reason" || reason ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                    <input className="flex-item" id="comment" value={reason} placeholder="Write your reason here..." onChange={handleReason} style={{width:"100%"}} type="text" />
                  </div>
                </div>
                <div onClick={()=>toggleSkipAggregateTax()} className="d-flex flex-item cursor-pointer">
                  <input className="flex-item m-r-12" type="checkbox" name="aggregate-tax" style={{width:"18px", height:"18px"}} checked={skipAggregateTax} />
                  <p className="flex-item color-red font-weight-700">Skip Aggregate Tax</p>
                </div>
              </div>
            }
          </div>
        </div>
          <div className='bottom-action-button d-flex space-between' style={{padding:"8px 12px", flexShrink: 0, position: "relative", bottom: "auto", left: "auto", right: "auto"}}>
            <div onClick={()=>props.togglePaymentModal("balance-payment")} className={`member-button-global btn-center d-flex member-button-global-inactive`} style={{ width: "48%", height:"40px", borderRadius:"20px" }}>
              <p className="flex-item">Cancel</p>
            </div>
            <div onClick={isButtonLock?null:PayBalanceAmount} className={`member-button-global btn-center d-flex`} style={{ width: "48%", height:"40px", borderRadius:"20px", background:isButtonLock?"#e0e0e0":"#E33A34",pointerEvents:isButtonLock?'none':'auto'}}>
              <p className="flex-item" style={{color:isButtonLock?"#4d4d4d":"#ffffff"}}>Submit</p>
            </div>
          </div>
        
        
      </div>
    </div>
  )
}

export default BalancePaymentModal;